<template>
    <div v-if="upsells.length > 0">
        <h2 class="fs-4 my-3 my-md-0 fw-bold">Choose your extras</h2>
        <div v-if="tyresInBasket?.length > 0" class="my-2">
            <div v-for=" (upsell, upsell_key) in coverageUpsells" class="col-12 border border-1 p-2 rounded">
                <div class="d-flex flex-column flex-sm-row">
                    <div class="service-bg d-flex flex-column justify-content-center" v-if="upsell.basket_image">
                        <img :src="basePath + upsell.basket_image" class="tp-service-image p-3" :alt="upsell.name" />
                    </div>
                    <div class="ms-sm-3 mt-2 mt-sm-0">
                        <div class="d-flex justify-content-between align-items-baseline mb-2">
                            <div class="d-inline-flex align-items-baseline gap-3">
                                <div class="d-flex flex-column align-items-baseline flex-xl-row">
                                    <h5 class="mb-2 mb-xl-0">{{ upsell.name }}</h5>
                                    <p class="mb-0 ps-xl-3"><b>Only £{{ upsell.retail }}</b> per tyre</p>
                                </div>
                            </div>
                            <button
                                @click="productInBasket(upsell.code) ? deleteServiceFromBasket(upsell.code) : addServiceToBasket(upsell.code, 1, true)"
                                :class="{'btn-danger': productInBasket(upsell.code)}" class="btn btn-primary"
                                v-html="productInBasket(upsell.code) ? 'Remove' : 'Add'">
                            </button>
                        </div>
                        <p class="d-block" v-html="upsell.basket_description"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row gx-3 mb-2">
            <div v-for="(upsell, upsell_key) in waSpecificUpsells" :key="upsell.id" class="col-12 my-2"
                :class="{'col-md-6': waSpecificUpsells.length == 2}">
                <div class="border border-1 p-2 rounded">
                    <div class="d-flex flex-column flex-xxl-row">
                        <div class="service-bg d-flex flex-column justify-content-center" v-if="upsell.basket_image">
                            <img :src="basePath + upsell.basket_image" class="wa-service-image p-4"
                                :alt="upsell.name" />
                        </div>
                        <div class="ms-sm-3 flex-grow-1 d-flex flex-column">
                            <div class="d-flex align-items-baseline justify-content-between mt-2">
                                <div class="d-block mb-2">
                                    <h5 class="mb-1">{{ upsell.name }}</h5>
                                    <span class="d-block fs-5">£{{ upsell.retail }}</span>
                                </div>
                                <button @click="toggleWAInBasket(upsell.code, productInBasket(upsell.code))"
                                    :class="{'btn-danger': productInBasket(upsell.code)}" class="btn btn-primary"
                                    v-html="productInBasket(upsell.code) ? 'Remove' : 'Add'">
                                </button>
                            </div>
                            <p class="d-block wa-service-p" v-html="upsell.basket_description"></p>
                            <p v-if="upsell?.long_description" class="d-inline-block text-underline cursor-pointer mb-0"
                                :class="linkColour" @click="toggleUpsellExplainedModal(upsell)">
                                Find out more
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row gx-3 gy-3">
            <div v-for="(upsell, upsell_key) in otherUpsells" :key="upsell.id"
                class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex flex-column">
                <div class="border border-1 p-2 rounded flex-grow-1 d-flex flex-column">
                    <div v-if="upsell.basket_image">
                        <img :src="basePath + upsell.basket_image" class="service-image w-100" :alt="upsell.name">
                    </div>
                    <div class="d-flex align-items-baseline justify-content-between flex-grow-1 mt-2">
                        <h5>{{ upsell.name }}</h5>
                        <i class="fa-regular fa-info-circle cursor-pointer"
                            @click="toggleUpsellExplainedModal(upsell)"></i>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-2">
                        <span class="d-block fs-5">
                            £{{ upsell.retail }}
                            <template v-if="isPerItemService(upsell)"> per tyre</template>
                        </span>
                        <button
                            @click="productInBasket(upsell.code) ? deleteServiceFromBasket(upsell.code) : addServiceToBasket(upsell.code, getServiceQuantity(upsell), true)"
                            :class="{'btn-danger': productInBasket(upsell.code)}" class="btn btn-primary"
                            v-html="productInBasket(upsell.code) ? 'Remove' : 'Add'">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="fitter">
        <h2 class="fs-4 my-3 my-md-0 fw-bold">No extras available.</h2>
        <p>Click the continue button to proceed.</p>
    </div>
    <service-explained-modal :service="modalUpsell" :service-explained-modal-open="serviceExplainedModalOpen"
        @closeModal="upsellExplainedModalOpen = false"></service-explained-modal>
</template>

<script>
    import basketFunctions from "@shared/mixins/basket";
    export default {
        mixins: [basketFunctions],
        props: ['fitter', 'basket', 'imageBasePath', 'fuelEnv', 'linkColour'],
        data() {
            return {
                upsells: [],
                updatedBasket: this.basket,
                waValues: ['WHEELALIGNMENT', 'RCWHEELALIGN4'],
                serviceExplainedModalOpen: false,
                modalUpsell: []
            }
        },
        mounted() {
            if(this.fitter) {
                this.getFitterUpsells();
            }

            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
                if(this.fitter) {
                    this.getFitterUpsells();
                }
            });
        },
        methods: {
            toggleUpsellExplainedModal(upsell) {
                this.modalUpsell = upsell;
                this.serviceExplainedModalOpen = true;
            },
            isPerItemService(upsell) {
                return Boolean(Number(upsell?.priced_per_item)) || upsell?.price_type === 'per_tyre';
            },
            getServiceQuantity(upsell) {
                if (!this.isPerItemService(upsell)) {
                    return 1;
                }

                const totalTyres = this.updatedBasket?.total_tyres ?? this.basket?.total_tyres ?? 0;

                return Math.max(1, Number(totalTyres) || 1);
            },
            async getFitterUpsells() {
                let formData = new FormData();
                let vm = this;
                this.emitter.emit('isLoading', true);

                formData.append('fitter', vm.fitter);
                formData.append('rules', true);
                await axios.post('/ajax/get_fitter_services', formData)
                .then(function (response) { 
                    vm.upsells = response.data.available;
                });

                this.emitter.emit('isLoading', false);
            }
        },
        computed: {
            waSpecificUpsells() {
                let vm = this;
                return this.upsells?.filter((upsell) => {
                    return (vm.waValues.includes(upsell.code));
                });
            },
            coverageUpsells() {
                let vm = this;
                return this.upsells?.filter((upsell) => {
                    return upsell.code == 'TYREPROTECTION';
                });
            },
            fourWaOffered() {
                return this.upsells?.filter((upsell) => {
                    return (upsell.code == 'RCWHEELALIGN4');
                });
            },
            otherUpsells() {
                let vm = this;
                return this.upsells?.filter((upsell) => {
                    return (!vm.waValues.includes(upsell.code) && upsell.code != 'TYREPROTECTION');
                });
            },
            tyresInBasket() {
                let filtered = this.updatedBasket?.products?.filter(product => product.product_type == 'product');
                return filtered;
            },
            basePath() {
                if(this.fuelEnv == 'development') {
                    return 'https://tyreadmin.test/storage/';
                }
                else if(this.fuelEnv == 'staging') {
                    return 'https://staging.tyres.colewood-automotive.co.uk/storage/';
                }
                else {
                    return this.imageBasePath;
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .basket-card {
        height: auto;
        border-radius: 0px;
    }
    .basket-card .card-header {
        border-radius: 0px;
        background-color: #0A2463; // variable this? how?
        color: white;
    }
    .service-bg {
        background-color: #F1F1F1;
        text-align: center;
    }
    .wa-service-image {
        max-width: 190px;
        margin: 0 auto;
    }
    .tp-service-image {
        max-width: 200px;
        margin: 0 auto;
    }
    @media screen and (min-width: 992px) and (max-width: 1199px) {
        .wa-service-p {
            min-height: 96px;
        }
    }
</style>